import {tStr} from "../../../../shared/utils/translateFunc";

export const data = {
  title: tStr("add_new_product"),
  subtitle: "Enter the product name. It will be displayed when the customer scans the QR code."
};